'use client';

import Link from 'next/link';
import Introduce from '@public/svgs/introduce.svg'
import Organization from '@public/svgs/organization.svg'
import Map from '@public/svgs/map.svg'

/**
 * 퀵링크 컴포넌트
 *
 * 주요 메뉴 링크를 제공하는 섹션입니다.
 * 메인 배너 하단에 표시되며 인사말, 조직도, 오시는길 링크를 제공합니다.
 */
export function QuickLinks() {
  return (
    <section className="relative w-full py-20 md:py-30 bg-gradient-to-b from-black via-gray-900 to-white">
      <div className="max-w-[1500px] mx-auto px-5 md:px-8">
        <div className="flex justify-center">
          <div className="bg-gradient-to-b from-[#000e] via-[#0001] to-[#000e] backdrop-blur-sm rounded-2xl md:rounded-[32px] border border-white/20">
            <div className="flex flex-row">
              {/* 인사말 링크 */}
              <Link href="/greeting" className="group relative flex flex-col gap-3 md:gap-6 justify-center items-center text-white hover:text-blue-200 transition-all duration-100 w-30 md:w-48 h-30 md:h-44 p-4">
                <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center">
                  <Introduce className="w-8 h-8 md:w-11 md:h-11" />
                </div>
                <span className="text-sm md:text-lg font-medium text-center">인사말</span>
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-18 md:w-30 h-[3px] md:h-[5px] bg-[#B62B5C] opacity-0 group-hover:opacity-100 transition-all duration-100" />
              </Link>

              {/* 조직도 링크 */}
              <Link href="/organization" className="group relative flex flex-col gap-3 md:gap-6 justify-center items-center text-white hover:text-blue-200 transition-all duration-100 w-30 md:w-48 h-30 md:h-44 p-4">
                <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center">
                  <Organization className="w-9 h-9 md:w-13 md:h-13" />
                </div>
                <span className="text-sm md:text-lg font-medium text-center">조직도</span>
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-18 md:w-30 h-[3px] md:h-[5px] bg-[#B62B5C] opacity-0 group-hover:opacity-100 transition-all duration-100" />
              </Link>

              {/* 오시는길 링크 */}
              <Link href="/location" className="group relative flex flex-col gap-3 md:gap-6 justify-center items-center text-white hover:text-blue-200 transition-all duration-100 w-30 md:w-48 h-30 md:h-44 p-4">
                <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center">
                  <Map className="w-8 h-8 md:w-12 md:h-12" />
                </div>
                <span className="text-sm md:text-lg font-medium text-center">오시는길</span>
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-18 md:w-30 h-[3px] md:h-[5px] bg-[#B62B5C] opacity-0 group-hover:opacity-100 transition-all duration-100" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
